var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "basicSettings"
    }
  }, [_c("a-tabs", {
    attrs: {
      activeKey: _vm.tabKey,
      animated: false
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("basicSettings.basicSetting")
    }
  }, [_c("basicSetting", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })], 1), _c("a-tab-pane", {
    key: "4",
    attrs: {
      tab: _vm.$t("basicSettings.transportCompany")
    }
  }, [_c("transportCompany")], 1), _c("a-tab-pane", {
    key: "5",
    attrs: {
      tab: "SEO"
    }
  }, [_c("SEO", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })], 1), _c("a-tab-pane", {
    key: "7",
    attrs: {
      tab: _vm.$t("basicSettings.emailSetting")
    }
  }, [_c("emailSetting", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })], 1), _c("a-tab-pane", {
    key: "10",
    attrs: {
      tab: _vm.$t("basicSettings.emailNotifySetting")
    }
  }, [_vm.tabKey == 10 ? [_c("emailNotifySetting", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })] : _vm._e()], 2), _c("a-tab-pane", {
    key: "8",
    attrs: {
      tab: _vm.$t("basicSettings.agreementSetting")
    }
  }, [_vm.tabKey == 8 ? [_c("agreement", {
    attrs: {
      systemSetting: _vm.systemSetting
    }
  })] : _vm._e()], 2), _c("a-tab-pane", {
    key: "13",
    attrs: {
      tab: _vm.$t("basicSettings.pagesetting")
    }
  }, [_c("pagesetting", {
    attrs: {
      "product-id": 4064,
      "spec-flag": 1
    }
  })], 1), _c("a-tab-pane", {
    key: "9",
    attrs: {
      tab: _vm.$t("basicSettings.customerService")
    }
  }, [_c("customerService")], 1), _c("a-tab-pane", {
    key: "12",
    attrs: {
      tab: _vm.$t("basicSettings.Watermark")
    }
  }, [_c("picWatermark")], 1), _c("a-tab-pane", {
    key: "6",
    attrs: {
      tab: _vm.$t("basicSettings.other")
    }
  }, [_c("other", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })], 1), _c("a-tab-pane", {
    key: "11",
    attrs: {
      tab: _vm.$t("basicSettings.socialLogin")
    }
  }, [_c("socile-login", {
    attrs: {
      systemSetting: _vm.systemSetting
    },
    on: {
      update: _vm.loadData
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };